import { render } from "./App.vue?vue&type=template&id=6840df7a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6840df7a&lang=css"
script.render = render

export default script